<template>
		<div style="width:100%;height:100%;">
			<!-- 主文 -->
			<div style="display: flex;justify-content: center;align-items: center;">
				<div style="display: flex;margin-top: 50px;">
					<div style="border-right:1px solid #efefef;">
						<div v-for="(item,index) in detaila" :key="index" @click="tapone(index)">
							<div :class="index!=0?'bjtops':''" style="display:flex;align-items:center;position:relative;">
								<div class="bttrue" >{{item.a}}</div>
								<div v-if="index!=tabIndexs" class="quan"></div>
								<img v-else class="quans"  src="../assets/banner/5.png"/>
							</div>
						</div>
					</div>
					<div style="margin-left:30px;width:900px;margin-bottom:30px;">
						<div style="display: flex;flex-direction: column;">
							<div style="margin-left:20px;margin-top: 20px;margin-bottom:30px;width:795px;">
								<div style="width:795px;height:150px;margin-bottom:30px;">
									<div class="jbxx" style="font-weight:bold;margin-bottom: 30px;">相关需求信息</div>
									<div style="text-align: left;margin-left:20px;display:flex;">
										<div v-for="(item,index) in dynamicTags" :key="index" @click="tap(index)">
											<div class="buttonv" :style="index==tabIndexc?'background-color:#20919D;':''">{{item.name}}</div>
										</div>
									</div>
								</div>
							</div>
							<div style="margin-left:20px;margin-top: 20px;width:795px;background-color:#F4F4F4;">
								<div style="width:795px;height:230px;margin-bottom:30px;">
									<div class="jbxx" style="font-weight:bold;">基本信息</div>
									<div class="xx bjtop" style="display: flex;">
										<div>
											机构名称<input v-model="title" maxlength="30" class="bjleft inputs" style="border:1px solid #dcdfe6;width:350px;margin-left:20px;background-color:#FAF7FA;"></input>
										</div>
										<div style="margin-left:20px;">
											手机号码<input v-model="phone" maxlength="11" class="bjleft inputs" style="border:1px solid #dcdfe6;margin-left:20px;background-color:#FAF7FA;"></input>
										</div>
									</div>
									<div class="xx bjtop" style="display: flex;">
										<div style="display: flex;">
											职务<div style="opacity:0;">哈哈</div><input v-model="job" maxlength="20" class="bjleft inputs" style="border:1px solid #dcdfe6;width:350px;margin-left:20px;background-color:#FAF7FA;"></input>
										</div>
										<div style="margin-left:20px;">
											姓名<input maxlength="20" v-model="name" class="bjleft inputs" style="border:1px solid #dcdfe6;margin-left:48px;background-color:#FAF7FA;"></input>
										</div>
									</div>
									<div class="xx bjtop" >微信号<div style="opacity:0;">哈</div><input maxlength="20" v-model="wechat" class="bjleft inputs" style="border:1px solid #dcdfe6;width:350px;margin-left:20px;background-color:#FAF7FA;"></input>
									</div>
									<div class="xx bjtop">机构简介<textarea v-model="info" class="bjleft inputs" type="text" style="border:1px solid #dcdfe6;width:345px;height:70px;margin-left:20px;resize : none;background-color:#FAF7FA;"></textarea>
									</div>
								</div>
							</div>
							<div style="margin-left:20px;margin-top:20px;width:795px;">
								<div style="width:795px;height: 300px;">
									<div class="jbxx" style="font-weight:bold;">需求类别</div>
									<div class="xx bjtop" style="display:flex;align-items:center;">
											<div>选择需求类别</div>
											<div style="margin-left:10px;opacity:0.5;">
												<el-select v-model="value" filterable  placeholder="请选择" size="mini">
												    <el-option
												      v-for="item in cities"
												      :key="item.value"	
												      :label="item.label"
												      :value="item.label">
												      <span style="float: left">{{ item.label }}</span>
												      <!-- <span style="float: right; color: #8492a6; font-size: 13px">{{ item.value }}</span> -->
												    </el-option>
												  </el-select>
											</div>
									</div>
									<div style="padding-left:30px;">
										<textarea v-model="content"  placeholder="请输入您的需求" class="bjleft xx wbk" style="border:1px solid #dcdfe6;"></textarea>
									</div>
								</div>
							</div>
							
							<el-dialog
							  title="提示"
							  :visible.sync="dialogVisible"
							  width="30%"
							  :before-close="handleClose">
							  <span>请正确的填写所有信息.</span>
							  <span slot="footer" class="dialog-footer">
							    <el-button @click="dialogVisible = false">取 消</el-button>
							    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
							  </span>
							</el-dialog>
							<!-- <div class="botton-two" @click="qrtj()">确认提交</div> -->
							<el-button type="text" ><div class="botton-two" @click="qrtj()">确认提交</div></el-button>
						</div>
					</div>
				</div>
			</div>
			
		</div>
</template>

<script>
	import axios from '../util/http.js'
	import base from '../util/base.js'
	export default {
		name:"detailstwo",
		components:{
		},
		data() {
			return {
				url:'https://www.baidu.com/',
				dynamicTags: [],
				inputVisible: false,
				inputValue: '',
				tabIndex:7,
				tabIndexs:0,
				tabIndexc:0,
				dialogVisible: false,
				detaila:[
					{a:'相关需求信息'},
					{a:'基本信息'},
					{a:'需求介绍'},
				],
				show:false,//验证手机号码
				shows:false,//验证注册资金
				showss:false,//验证公司规模
				cities: [{
						  label: '找资金'
						},
						{
						label: '找项目'
								},
						{
								  label: '园区招商'
								},
						{
								  label: '会议合作'
								},
						{
								  label: '找专业服务'
								},
						{
								  label: '其他'
								},								
						],
				        value: '',
						id:'1',//确认提交的id传参
						title:'',//确认提交的公司名称传参
						phone:'',//确认提交的电话传参
						name:'',//确认提交的姓名传参
						wechat:'',//确认提交的微信号
						job:'',//确认提交的职务
						info:'',//确认提交的机构简介
						city:'',//确认提交的地区传参
						content:'',//确认提交的需求内容
						a:'<p>',
						b:'</p>',
			}
		},
		//监听事件
		mounted() {
		    window.addEventListener("scroll", this.showIcon);
		},
		created() {
				//获取需求发布标签
				axios({
				    url: `${base.url}/api/user/resourcesLabel`,
				    method: 'post',
				    data:''
				}).then((res) => {
					if(res.code==1){
						// //map循环添加元素到数组
						// res.data.map(item=>{
						// 	this.dynamicTags.push(item.name)
						// })
						this.dynamicTags=res.data
					}
				        })
		},
		methods: {
			showIcon() {
			   if (!!document.documentElement.scrollTop &&document.documentElement.scrollTop > 100) {            
					this.tabIndexs=2
			     } else if(!!document.documentElement.scrollTop &&document.documentElement.scrollTop > 50) {
			        this.tabIndexs=1
			     }else{
					 this.tabIndexs=0
				 }
			 },
			change:function(e){
				console.log(e);
				this.tabIndex=e
				switch(e){
					case 0:
						this.$router.push({name:'Home'});
						break;
					case 1:
						this.$router.push({name:'modify'});
						break;
					case 2:
						this.$router.push({name:'Research'});
						break;
					case 3:
						this.$router.push({name:'college'});
						break;
					case 4:
						this.$router.push({name:'character'});
						break;
					case 5:
						this.$router.push({name:'Resource'});
						break;
					case 6:
						this.$router.push({name:'recommendation'});
						break;	 				
				 }
				this.$store.commit("navbgshow",e)
		},
		qrtj:function(){
			//判断电话号码
			const phoneReg = /(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/;
			this.show=phoneReg.test(this.phone);
			if(this.show==false){
				this.open()
			}else{
				if(this.title==''){
					this.dialogVisible = true
				}else if(this.phone==''){
					this.dialogVisible = true	
				}else if(this.value==''){
					this.dialogVisible = true	
				}
				else if(this.name==''){
					this.dialogVisible = true
				}else if(this.wechat==''){
					this.dialogVisible = true
				}else if(this.info==''){
					this.dialogVisible = true
				}else if(this.data==''){
					this.dialogVisible = true
				}else if(this.content==''){
					this.dialogVisible = true
				}else{
					this.content=this.a.concat(this.content).concat(this.b)
					//提交需求接口
					const data={
						pid:this.id,
						title:this.title,
						phone:this.phone,
						name:this.name,
						job:this.job,
						wechat:this.wechat,
						// data:this.data,
						// city:this.value,
						content:this.content,
					}
					axios({
					    url: `${base.url}/api/user/submits`,
					    method: 'post',
					    data:data
					}).then((res) => {
						if(res.code==1){
							console.log(res);
							this.dialogVisible = false
							this.$router.push({name:'page'});
							this.$store.commit("navbgshow",0)
						}
					        })
						
				}
			}
		},
		tzxx:function(e){
			this.tabIndexs=e
		},
		tap:function(e){
			this.tabIndexc=e
			this.id=this.dynamicTags[e].id
		},
		 handleClose(tag) {
		        this.dynamicTags.splice(this.dynamicTags.indexOf(tag), 1);
		      },
		      showInput() {
		        this.inputVisible = true;
		        this.$nextTick(_ => {
		          this.$refs.saveTagInput.$refs.input.focus();
		        });
		      },
		      handleInputConfirm() {
		        let inputValue = this.inputValue;
		        if (inputValue) {
		          this.dynamicTags.push(inputValue);
		        }
		        this.inputVisible = false;
		        this.inputValue = '';
		      },
			  tapone(e){
				  this.tabIndexs=e;
				  console.log(e);
				  if(e==1){
					  window.scrollTo(0, document.documentElement.scrollHeight-document.documentElement.clientHeight); 
				  }else if(e==2){
					  window.scrollTo(0, document.documentElement.scrollHeight-document.documentElement.clientHeight); 
				  }
			  },
			  fhsy(){
			  	this.$router.push({name:'page'});
			  	this.$store.commit("navbgshow",0)
			  },
			  open() {
			          this.$message('请输入正确的电话号码');
			        },
			  opens() {
			          this.$message('请输入正确的注册资金且以万为单位');
			        },	
			  openss() {
			          this.$message('请输入正确的公司规模且以人为单位');
			        },
			   handleClose(done) {
			          this.$confirm('确认关闭？')
			            .then(_ => {
			              done();
			            })
			            .catch(_ => {});
			        }
			  }
	}
</script>

<style lang="scss" scoped>
	.bttrue{
		width:100px;
		text-align:right;
		padding-right:30px;
	}
	.bttrue:hover{
	cursor:pointer;
	}
	.wbk{
		background-color:#FAF7FA;
		width:500px;
		height:170px;
		margin-top:20px;
		padding-top:10px;
		padding-left:10px;
		resize : none;
		border: 0;  // 去除未选中状态边框
		outline: none; // 去除选中状态边框
	}
	.buttonv{
		cursor:pointer;
		font-size:14px;
		background-color:#5BD5D0;
		margin-left:20px;
		color:white;
		text-align:center;
		border-radius: 4px;
		padding:5px 10px;
		box-sizing: border-box;
	}
	.element .style {
	    text-align: left;
	    margin-left: 20px;
	}
	.button-new-tag[data-v-41e2b943] {
	    margin-left: 10px;
	    height: 32px;
	    line-height: 30px;
	    padding-top: 1px;
	    padding-bottom: 0;
	}
	.zwk{
		margin:0px 10px 0px 0px;
		width: 348px;
		height:695px;
		background-color:#ffffff;
	}
	.botton-two{
		background-color:#169BD5;
		border-radius: 4px;
		color: white;
		width:100px;
		height: 30px;
		line-height:30px;
		font-size:12px;
		margin-left:720px;
		margin-bottom:30px;
	}
	.xx{
		text-align: left;
		display: flex;
		margin-left: 20px;
		font-size:14px;
	}
	.zwk2{
		width: 863px;
		height:695px;
		background-color:#ffffff;
	}
	.jbxx{
		background-color:#FAF7FA;
		height:53px;
		line-height:53px;
		text-align:left;
		padding-left:20px;
	}
	.bjtops{
		margin-top:20px;
	}
	.quan{
		background-color: #BCBCBC;
		width:9px;
		height:9px;
		border-radius:100px;
		position:absolute;
		right:-5px;
	}
	.inputs{
		 border: 0;  // 去除未选中状态边框
		 outline: none; // 去除选中状态边框
		 background-color: rgba(0, 0, 0, 0);// 透明背景
	}
	.quans{
		position:absolute;
		right:-10px;
		top:1px;
	}
	.color{
		color: #FFFFFF;
		width:135px;
		height:42px;
		line-height: 42px;
		text-align: center ;
	}
	.serch{
		color:#FFFFFF;
		font-size:10px;
		background-color:#20919D;
		text-align:center;
		height: 31px;
		line-height:31px;
		width:50px;
	}
	.flex{
		display:flex;
	}
	.flexjust{
		justify-content: center;
	}
	.flexali{
		align-items: center;
	}
	.colorwhite{
		color: #FFFFFF;
	}
	.dhl{
		color:#FFFFFF;
		font-size:15px;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.dhls{
		color:#FFFFFF;
		font-size:15px;
		background-color: #59D4CF;
		display:flex;
		justify-content: center;
		align-items: center;
		padding:0 20px;
	}
	.Line{
		width:1px;
		height: 14px;
		background-color:#FFFFFF;
	}
	.font{
		font-size:14px;
	}
	.por{
		display:flex;
		flex-direction: column;
		margin-left:10px;
	}
	.bodya{
		background-color:#5AD6CE;
		width:100px;
		height:86.9px;
		flex-direction: column;
		display: flex;
		justify-content: center;
		align-items: center;
		color: #FFFFFF;
	}
	.iur{
		margin-left: 5px;
	}
	.bjtop{
		margin-top: 10px;
	}
	.bjleft{
		margin-left:10px;
	}
	.bjright{
		margin-right:10px;
	}
	.bjbottom{
		margin-bottom:10px;
	}
	.zxls{
		text-align: left;
		color:#181818;
		font-size:16px;
	}
	.el-tag + .el-tag {
	    margin-left: 10px;
	  }
	  .button-new-tag {
	    margin-left: 10px;
	    height: 32px;
	    line-height: 30px;
	    padding-top: 0;
	    padding-bottom: 0;
	  }
	  .input-new-tag {
	    width: 90px;
	    margin-left: 10px;
	    vertical-align: bottom;
	  }
	  .router-link-active {
	    text-decoration: none;
	  }
	  a {
	    text-decoration: none;
	  }
</style>
